import { FC } from 'react';

import { useFindAllProducts } from '../hooks/useProducts';

export const ProductsProvider: FC = () => {
  useFindAllProducts();

  return null;
};
